import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";
import PropTypes from "prop-types";

const VideoPreview = ({ image, videoUrl }) => {
    const [toggler, setToggler] = useState(false);

    return (
        <div className="video-popup icon-center">
            <div className="thumbnail position-relative">
                {/* Image as the thumbnail */}
                <img className="radius-small img-fluid" src={image} alt="Course Thumbnail" />

                {/* Play Button in the center */}
                <div className="video-icon position-absolute top-50 start-50 translate-middle">
                    <button
                        className="btn-default rounded-player"
                        onClick={() => setToggler(!toggler)}
                        style={{
                            fontSize: "30px",  // slightly bigger font size
                            padding: "16px 20px",  // increased padding for better clickable area
                            backgroundColor: "rgba(255, 255, 255, 0.7)",  // semi-transparent background
                            border: "none",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "transform 0.3s ease",
                        }}
                    >
                        <span><FiPlay /></span>
                    </button>
                </div>
            </div>

            {/* FS Lightbox */}
            <FsLightbox toggler={toggler} sources={[videoUrl]} />
        </div>
    );
};

// Prop Types for type checking
VideoPreview.propTypes = {
    image: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
};

export default VideoPreview;
